// Core Components
import VTelInput from "@/components/Shared/Inputs/VTelInput.vue";

function setupComponents(Vue) {
  Vue.component("v-tel-field", VTelInput);
}

export { setupComponents };
